import axios from 'axios';

const global = require('../config/config');

// Função getInfoTextos - icon só true se ServAtivo=true
async function getInfoTextos(infoJson) {
  try {
    const API_URL_TEXTOS = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetInfoTextos/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_TEXTOS);
    const apiTextos = res.data || {};

    const mergedTextos = Object.keys(apiTextos).reduce((acc, key) => {
      acc[key] = {
        Titulo: apiTextos[key]?.Titulo?.trim() || infoJson[key]?.titulo?.trim() || '',
        SubTitulo: apiTextos[key]?.SubTitulo?.trim() || infoJson[key]?.subTitulo?.trim() || '',
        Zona: apiTextos[key]?.Zona?.trim() || infoJson[key]?.zona?.trim() || '',
        Url: apiTextos[key]?.Url?.trim() || infoJson[key]?.url?.trim() || '',
        MetaTitle: apiTextos[key]?.MetaTitle?.trim() || infoJson[key]?.metaTitle?.trim() || '',
        Banner:
          apiTextos[key]?.Banner && apiTextos[key].Banner !== 0
            ? apiTextos[key].Banner
            : infoJson[key]?.banner || infoJson[key]?.Pagina?.codBanner || '',
        Layout: infoJson[key]?.Pagina?.Layout || 'Full-width',
        Video: infoJson[key]?.Video?.Src || infoJson[key]?.Pagina?.Video || '',
        CodEquipa: infoJson[key]?.Pagina?.codEquipa || '',
        ListagemNumero: infoJson[key]?.Pagina?.listagemNumero || '',
        TipoPagina: infoJson[key]?.Pagina?.tipo || '',
        // Se vem da API: icon = true se ServAtivo=true, senão false
        icon: apiTextos[key]?.ServAtivo === true ? true : false,
        existe:
          apiTextos[key]?.ServAtivo !== undefined && apiTextos[key]?.ServAtivo !== null
            ? apiTextos[key]?.ServAtivo
            : infoJson[key]?.existe || false,
      };

      return acc;
    }, {});

    // 👉 Guardar codNoticiasCategoria corretamente
    if (apiTextos.Noticias?.codNoticiasCategoria) {
      mergedTextos.Noticias = {
        ...mergedTextos.Noticias,
        codNoticiasCategoria: apiTextos.Noticias.codNoticiasCategoria,
      };
    }

    // 👉 Guardar codAlbum_Clientes como codAlbumClientesCategoria dentro de AlbumClientes
    if (apiTextos.Noticias?.codAlbum_Clientes) {
      mergedTextos.AlbumClientes = {
        ...mergedTextos.AlbumClientes,
        codAlbumClientesCategoria: apiTextos.Noticias.codAlbum_Clientes,
      };
    }

    // Garante que o Banner da Empresa é corretamente tratado
    mergedTextos.Empresa = {
      ...mergedTextos.Empresa,
      Banner:
        apiTextos.Empresa?.Banner && apiTextos.Empresa.Banner !== 0
          ? apiTextos.Empresa.Banner
          : infoJson.Banner?.Empresa || '',
    };

    // Adiciona um único objeto "Banner" com Mobile, Desktop e Empresa ao resultado final
    mergedTextos.Banner = {
      Mobile: infoJson.Banner?.Mobile,
      Desktop: infoJson.Banner?.Desktop,
    };

    return mergedTextos;
  } catch (error) {
    console.error('Erro ao buscar os textos:', error.response?.data || error.message);
    return infoJson; // Se houver erro, retorna os dados locais
  }
}

async function getInfoPopUp(infoJson) {
  try {
    const API_URL_TEXTOS = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetPopUp/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_TEXTOS);
    const textos = res.data;
    return textos;
  } catch (error) {
    console.log('error', error);
  }
}

async function getInfoEmpresa(infoJson) {
  try {
    var API_URL_INFO = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetContactosClienteAll/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_INFO);
    const info = res.data;
    return info;
  } catch (error) {
    console.log('error', error);
  }
}

async function getBanner(codBanner, infoJson) {
  try {
    const API_URL_BANNERS = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetBanner/`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
        zona_id: codBanner,
        numero: infoJson.Banner.Top,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_BANNERS);

    if (res.data.length > 0) {
      const banners = res.data;
      return banners;
    }
    return [];
  } catch (error) {
    console.log('error', error);
  }
}

async function getServicoOficina(infoJson) {
  try {
    const API_URL_SERVICOS_OFICINA = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetServicoOficina/`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_SERVICOS_OFICINA);
    const servico = res.data;

    return servico;
  } catch (error) {
    console.log('error', error);
  }
}

async function getHorarios(CodPontoVenda, Concelho, infoJson) {
  try {
    const API_URl_HORARIOS = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetHorario/`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
        stand_id: CodPontoVenda,
        country: Concelho,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URl_HORARIOS);
    const servico = res.data;

    return servico;
  } catch (error) {
    console.log('error', error);
  }
}

async function getIntervaloPreco(infoJson) {
  try {
    const API_URl_INTERVALO = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetIntervaloPreco/`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URl_INTERVALO);
    const intervalo = res.data;

    return intervalo;
  } catch (error) {
    console.log('error', error);
  }
}
async function getIntervaloPrecoTipo(infoJson) {
  try {
    const API_URl_INTERVALO_TIPO = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetIntervaloPreco/tipo`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URl_INTERVALO_TIPO);
    return res.data?.tipo_visualizacao;
  } catch (error) {
    console.error('Erro ao obter tipo de visualização do intervalo de preço:', error.message);
    return null;
  }
}

async function getIntervaloMensalidade(infoJson) {
  try {
    const API_URl_INTERVALO = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetIntervaloMensalidade/`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URl_INTERVALO);
    const intervalo = res.data;

    return intervalo;
  } catch (error) {
    console.log('error', error);
  }
}
async function getIntervaloMensalidadeTipo(infoJson) {
  try {
    const API_URl_INTERVALO_TIPO = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/GetIntervaloMensalidade/tipo`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };
    const res = await axios.request(API_URl_INTERVALO_TIPO);
    
    return res.data?.tipo_visualizacao;
  } catch (error) {
    console.error('❌ ERRO na chamada da API:', error); // ← MELHORA
    console.error('❌ Error message:', error.message); // ← ADICIONA
    console.error('❌ Error response:', error.response?.data); // ← ADICIONA
    return null;
  }
}

async function getPrivacidade(infoJson) {
  try {
    const API_URl_INTERVALO = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/privacidade/`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URl_INTERVALO);
    const intervalo = res.data;

    return intervalo;
  } catch (error) {
    console.log('error', error);
  }
}

async function getCookies(infoJson, nomeEmpresa, email) {
  try {
    const API_URl_INTERVALO = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/empresa/cookies/`,
      params: {
        dealer_id: infoJson.Stand.Anunciante,
        nomeEmpresa,
        email,
      },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URl_INTERVALO);
    const intervalo = res.data;

    return intervalo;
  } catch (error) {
    console.log('error', error);
  }
}

async function getPlugins(infoJson) {
  try {
    const API_URL_PLUGINS = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetPlugins/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };
    // dados da api
    const res = await axios.request(API_URL_PLUGINS);
    const data = res.data[0]; // Garantir que acessamos o objeto correto

    const plugins = {
      PluginFacebook: {
        existe: data.FacebookAtivo,
        pixelId: data.FacebookId || '',
        facebookDomainVerification: data.FacebookDomainVerification || '',
      },
      WidgetWhats: {
        existe: data.WhatsappAtivo,
        dataWwa: data.WhatsappId || '',
      },
      OneSignal: {
        existe: data.OneSignalAtivo,
        appId: data.OneSignalId || '',
      },
      WidgeAvaly: {
        existe: data.AvalyAtivo,
        id: data.AvalyId || '',
      },
      Lead2team: {
        existe: data.Lead2TeamAtivo,
        apiKey: data.Lead2TeamId || '',
      },
      GoogleAnalytics: {
        existe: data.GoogleAtivo,
        measurementIds: [data.GoogleAnalytics, data.GoogleTagsManager],
      },
      AutoUncle: {
        existe: data.AutoUncleAtivo,
        config: {
          id: data.AutoUncleId || '',
        },
      },
      Tiktok: {
        existe: data.TiktokAtivo,
        id: data.TiktokId || '',
      },
      OneTrust: {
        existe: data.OneTrustAtivo,
        id: data.OneTrustId || '',
      },
    };

    // infojson

    return {
      PluginFacebook: {
        ...(plugins.PluginFacebook.existe
          ? plugins.PluginFacebook
          : infoJson.Stand.PluginFacebok?.existe
            ? infoJson.Stand.PluginFacebok
            : plugins.PluginFacebook),
      },
      WidgetWhats: {
        ...(plugins.WidgetWhats.existe
          ? plugins.WidgetWhats
          : infoJson.Stand.WidgetWhats?.existe
            ? infoJson.Stand.WidgetWhats
            : plugins.WidgetWhats),
      },
      OneSignal: {
        ...(plugins.OneSignal.existe
          ? plugins.OneSignal
          : infoJson.Stand.OneSignal?.existe
            ? infoJson.Stand.OneSignal
            : plugins.OneSignal),
      },
      WidgeAvaly: {
        ...(plugins.WidgeAvaly.existe
          ? plugins.WidgeAvaly
          : infoJson.Stand.WidgeAvaly?.existe
            ? infoJson.Stand.WidgeAvaly
            : plugins.WidgeAvaly),
      },
      Lead2team: {
        ...(plugins.Lead2team.existe
          ? plugins.Lead2team
          : infoJson.Stand.Lead2team?.existe
            ? infoJson.Stand.Lead2team
            : plugins.Lead2team),
      },
      GoogleAnalytics: {
        ...(plugins.GoogleAnalytics.existe
          ? plugins.GoogleAnalytics
          : infoJson.Stand.GoogleAnalytics?.existe
            ? infoJson.Stand.GoogleAnalytics
            : plugins.GoogleAnalytics),
      },
      AutoUncle: {
        ...(plugins.AutoUncle.existe
          ? plugins.AutoUncle
          : infoJson.Stand.AutoUncle?.existe
            ? infoJson.Stand.AutoUncle
            : plugins.AutoUncle),
      },
      Tiktok: {
        ...(plugins.Tiktok.existe
          ? plugins.Tiktok
          : infoJson.Stand.Tiktok?.existe
            ? infoJson.Stand.Tiktok
            : plugins.Tiktok),
      },
      OneTrust: {
        ...(plugins.OneTrust.existe
          ? plugins.OneTrust
          : infoJson.Stand.OneTrust?.existe
            ? infoJson.Stand.OneTrust
            : plugins.OneTrust),
      },
    };
  } catch (error) {
    console.error('Error fetching plugins:', error.response?.data || error.message);

    return infoJson.Stand;
  }
}

async function getPesquisa(infoJson) {
  try {
    const API_URL_PESQUISA = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetPesquisa/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };
    const res = await axios.request(API_URL_PESQUISA);
    const data = res.data;

    const pesquisa = data && Object.keys(data).length > 0 ? data : infoJson.Pesquisa;

    // Mapeamento do tipo de pesquisa
    const tipoPesquisaMap = {
      pesquisa_texto: 1,
      pesquisa_dois_campos: 5,
      pesquisa_tres_campos_linha: 3,
      pesquisa_tres_campos_bloco: 6,
      sobreposta_banner: 2,
      pesquisa_detalhada: 1,
      sem_pesquisa: 1,
    };

    let resultado = '';

    resultado = {
      existe: pesquisa.tipoPesquisa.tipo_pesquisa !== 'sem_pesquisa',
      rapida: {
        tipo: tipoPesquisaMap[pesquisa.tipoPesquisa.tipo_pesquisa] || infoJson.Pesquisa.rapida.tipo,
      },
      avancada: {
        principal: pesquisa.tipoPesquisa.tipo_pesquisa === 'pesquisa_detalhada',
      },
    };

    return resultado;
  } catch (error) {
    console.error('Error fetching pesquisa:', error.response?.data || error.message);
    return infoJson.Pesquisa;
  }
}

async function getUltimasEntradas(infoJson) {
  try {
    const API_URL_UltimasEntradas = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetUltimasEntradas/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_UltimasEntradas);
    const apiUltimasEntradas = res.data;

    const valoresValidos = {
      circulo: 1,
      rectangulo: 3,
    };

    let existe = infoJson.Layout?.UltimasEntradas?.existe;

    if (apiUltimasEntradas?.TipoEntrada) {
      if (apiUltimasEntradas?.TipoEntrada === 'inativo') {
        existe = false;
      } else if (valoresValidos[apiUltimasEntradas?.TipoEntrada]) {
        existe = true;
      }
    }

    const UltimasEntradas = {
      ...infoJson.Layout.UltimasEntradas,
      existe: existe,
      tipo: apiUltimasEntradas?.TipoEntrada
        ? valoresValidos[apiUltimasEntradas.TipoEntrada]
        : infoJson.Layout?.UltimasEntradas?.tipo,
      ordenacao:
        apiUltimasEntradas?.TipoOrdenacao?.trim() ??
        infoJson.Layout?.UltimasEntradas?.ordenacao ??
        'DataCriacao',
      top: apiUltimasEntradas?.NumeroCarros ?? infoJson.Layout?.UltimasEntradas?.top ?? 10,
    };

    return UltimasEntradas;
  } catch (error) {
    console.error('Error fetching Ultimas Entradas:', error.message);

    return {
      ...infoJson.Layout.UltimasEntradas,
      existe: infoJson.Layout?.UltimasEntradas?.existe ?? true, // Mantém o valor existente ou usa true como padrão
      tipo: infoJson.Layout?.UltimasEntradas?.tipo ?? null,
      ordenacao: infoJson.Layout?.UltimasEntradas?.ordenacao ?? 'DataCriacao',
      top: infoJson.Layout?.UltimasEntradas?.top ?? 10,
    };
  }
}
async function getVendidos(infoJson) {
  try {
    const API_URL_Vendidos = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetVendidos/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_Vendidos);
    const apiVendidos = res.data;

    const valoresValidos = {
      circulo: 1,
      rectangulo: 3,
    };

    let existe = infoJson.Layout?.Vendidos?.existe;

    if (apiVendidos?.TipoVisualizacao) {
      if (apiVendidos.TipoVisualizacao === 'inativo') {
        existe = false;
      } else if (valoresValidos[apiVendidos.TipoVisualizacao]) {
        existe = true;
      }
    }

    const Vendidos = {
      ...infoJson.Layout?.Vendidos,
      existe: existe,
      tipo: apiVendidos?.TipoVisualizacao
        ? valoresValidos[apiVendidos.TipoVisualizacao]
        : infoJson.Layout?.Vendidos?.tipo,
      top: apiVendidos?.NumeroCarros ?? infoJson.Layout?.Vendidos?.top ?? 10,
    };

    return Vendidos;
  } catch (error) {
    console.error('Error fetching Vendidos:', error.message);

    return {
      ...infoJson.Layout?.Vendidos,
      existe: infoJson.Layout?.Vendidos?.existe ?? true,
      tipo: infoJson.Layout?.Vendidos?.tipo ?? null,
      top: infoJson.Layout?.Vendidos?.top ?? 10,
    };
  }
}

//************************************* */

async function getZonas(infoJson) {
  try {
    // Log da configuração da API
    const API_URL_Zonas = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/getZonas/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_Zonas);

    const data = res.data;

    const zonasApi = data?.ativaZona || {};

    const novoLayout = structuredClone(infoJson.Layout); // manter imutabilidade

    // Mapeamento de campos da BD para Layout
    const mapaZonas = {
      album_clientes: 'AlbumClientes',
      destaques: 'Destaques',
      intervalo_preco: 'intervaloPreco',
      intervalos_mensalidade: 'intervaloMensalidades',
      listagem: 'Carros',
      marcas: 'Marcas',
      noticias: 'Noticias',
      quem_somos: 'QuemSomos',
      servicos: 'Servicos',
      testemunhos: 'Testemunhos',
      tipos: 'Tipos',
      ultimas_entradas: 'UltimasEntradas',
      vendidos: 'Vendidos',
    };

    Object.entries(mapaZonas).forEach(([campoBD, campoLayout]) => {
      const valor = zonasApi[campoBD];

      if (valor !== undefined && novoLayout[campoLayout]) {
        // const valorAnterior = novoLayout[campoLayout].existe;
        novoLayout[campoLayout] = {
          ...novoLayout[campoLayout],
          existe: valor,
        };
        // console.log(`    • Atualizado: ${valorAnterior} -> ${valor}`);
      } else {
        // console.log(`    • Não atualizado (valor undefined ou campo não existe)`);

      }
    });

    // Dados que serão retornados
    const resultado = {
      ...infoJson,
      Layout: novoLayout,
    };

    return resultado;
  } catch (error) {
    console.error('ERRO em getZonas:');

    return infoJson; 
  }
}
async function getInfoAtivarSite(infoJson) {
  try {
    const API_URL_ATIVAR_SITE = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetAtivarSite/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_ATIVAR_SITE);
    const data = res.data;

    return data;
  } catch (error) {
    console.log('Error fetching ativar site:', error.response?.data || error.message);
    return '';
  }
}

async function getDestaque(infoJson) {
  try {
    const API_URL_DESTAQUE = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetDestaque/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_DESTAQUE);
    const data = res.data;

    if (data && Object.keys(data).length > 0) {
      let resultado = '';

      resultado = {
        destaquesBanner: {
          existe: data.tipoDestaque.tipo_destaque === 3,
          TipoDestaques: infoJson.Layout.Destaques.destaquesBanner.TipoDestaques,
        },
        existe: data.tipoDestaque.tipo_destaque !== 6 && data.tipoDestaque.tipo_destaque !== 3,
        aparecerVendidos: infoJson.Layout.Destaques.aparecerVendidos,
        naoAparecerBtnToStock: infoJson.Layout.Destaques.naoAparecerBtnToStock,
        tipo: data.tipoDestaque.tipo_destaque,
      };

      return resultado;
    } else {
      return infoJson.Layout.Destaques;
    }
  } catch (error) {
    console.error('Error fetching destaque:', error.response?.data || error.message);
    return infoJson.Layout.Destaque;
  }
}

async function getEditarServicos(infoJson) {
  try {
    const API_URL_EDITAR_SERVICOS = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetEditarServicos/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_EDITAR_SERVICOS);
    const data = res.data;

    if (data && Object.keys(data).length > 0) {
      return data.editarServicos.tipo_servico;
    } else {
      return infoJson.Layout.Servicos.tipo;
    }
  } catch (error) {
    console.error('Error fetching Serviços:', error.response?.data || error.message);
    return infoJson.Layout.Servicos.tipo;
  }
}

async function getTipoListagem(infoJson) {
  try {
    const API_URL_TIPO_LISTAGEM = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetTipoListagem/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_TIPO_LISTAGEM);
    const data = res.data;

    if (data && Object.keys(data).length > 0) {
      let ordenar = {};

      if (data.tipoListagem.ordenar_listagem === 7) {
        ordenar = {
          recentes: true,
          tipo: 7,
          vendidosMisturados: infoJson.Layout.Carros.ordenar.vendidosMisturados,
        };
      } else {
        ordenar = {
          recentes: false,
          tipo: data.tipoListagem.ordenar_listagem,
          vendidosMisturados: infoJson.Layout.Carros.ordenar.vendidosMisturados,
        };
      }
      return {
        Carros: {
          listagemTipo: data.tipoListagem.tipo_listagem,
          tagTipo: data.tipoListagem.tipo_etiqueta,
          ordenar: ordenar,
          listagemNumero:
            data.tipoListagem.tipo_listagem === 1
              ? 4
              : data.tipoListagem.tipo_listagem === 2
                ? 2
                : data.tipoListagem.tipo_listagem === 3
                  ? 1
                  : data.tipoListagem.tipo_listagem === 4
                    ? 3
                    : null,
        },
        loadMore: data.tipoListagem.carregamento_listagem === 2 ? true : false,
        TagImg: {
          Geral: data.tipoListagem.cor_etiqueta,
        },
      };
    } else {
      return {
        Carros: {
          listagemTipo: infoJson.Layout.Carros.listagemTipo,
          tagTipo: infoJson.Layout.Carros.tagTipo,
          ordenar: {
            ...infoJson.Layout.Carros.ordenar,
          },
          listagemNumero: infoJson.Layout.Carros.listagemNumero,
        },
        loadMore: infoJson.Layout.loadMore,
        TagImg: {
          Geral: infoJson.Cores.TagImg.Geral ? infoJson.Cores.TagImg.Geral : infoJson.Cores.TagImg,
        },
      };
    }
  } catch (error) {
    console.error('Error fetching tipo listagem:', error.response?.data || error.message);

    return {
      Carros: {
        listagemTipo: infoJson.Layout.Carros.listagemTipo,
        tagTipo: infoJson.Layout.Carros.tagTipo,
        ordenar: {
          ...infoJson.Layout.Carros.ordenar,
        },
        listagemNumero: infoJson.Layout.Carros.listagemNumero,
      },
      loadMore: infoJson.Layout.loadMore,
      TagImg: {
        Geral: infoJson.Cores.TagImg.Geral ? infoJson.Cores.TagImg.Geral : infoJson.Cores.TagImg,
      },
    };
  }
}

async function getOrdenacaoSeccoes(infoJson) {
  try {
    const API_URL_ORDENACAO = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetOdenacaoSeccoes/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL_ORDENACAO);
    const data = res.data;

    const dadosValidos = Array.isArray(data) && data.length > 0;

    if (dadosValidos) {
      const normalizar = str =>
        str
          .toLowerCase()
          .replace(/[\s_]/g, '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');

      const equivalencias = {
        destaques: 'Destaques',
        ultimasentradas: 'Ultimas Entradas',
        servicos: 'Serviços',
        tipos: 'Segmentos',
        intervalopreco: 'Intervalo Preço',
        listagem: 'Listagem',
        albumclientes: 'Album Clientes',
        noticias: 'Noticias',
        testemunhos: 'Testemunhos',
        intervalomensalidades: 'Intervalo Mensalidades',
        quemsomos: 'Quem Somos',
        vendidos: 'Vendidos',
        marcas: 'Marcas',
      };

      const mapaPosicoes = {};
      data.forEach(item => {
        const chave = normalizar(item.tipoSecao);
        mapaPosicoes[chave] = item.posicao;
      });

      const novaOrdenacao = infoJson.Home.map(secao => {
        const chaveOriginal = normalizar(secao.nome);
        const chaveEquivalente = normalizar(equivalencias[chaveOriginal] || secao.nome);
        return {
          ...secao,
          ordenador: mapaPosicoes[chaveEquivalente] ?? secao.ordenador,
        };
      });

      return {
        secoes: novaOrdenacao.sort((a, b) => a.ordenador - b.ordenador),
      };
    } else {
      return {
        secoes: infoJson.Home.sort((a, b) => a.ordenador - b.ordenador),
      };
    }
  } catch (error) {
    console.error('❌ Erro ao buscar ordenação de secções:', error.response?.data || error.message);
    return {
      secoes: infoJson.Home.sort((a, b) => a.ordenador - b.ordenador),
    };
  }
}

async function getNoticiasConfig(infoJson) {
  try {
    const API_URL = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetNoticias3bConfig/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL);
    const config = res.data?.config;

    const temDadosBD = config && 
                       typeof config === 'object' && 
                       Object.keys(config).length > 0 &&
                       (config.noticias_proprias_ativo !== undefined || 
                        config.noticias_carmine_ativo !== undefined);

    if (temDadosBD) {
      return {
        existeNoticiasProprias: !!config.noticias_proprias_ativo,
        existeNoticiasCarmine: !!config.noticias_carmine_ativo,
        topNoticias: config.top_noticias ?? infoJson.Layout?.Noticias?.top ?? 0,
        tipoDestaque: config.tipo_destaque === 'destaques' ? 1 : 0,
        origemBD: true,
        externas: !!config.noticias_carmine_ativo
      };
    } else {
      return {
        existeNoticiasProprias: false,
        existeNoticiasCarmine: false,
        topNoticias: infoJson.Layout?.Noticias?.top ?? 0,
        tipoDestaque: infoJson.Layout?.Noticias?.destaque ?? 0,
        origemBD: false,
        externas: infoJson.Noticias?.externas ?? false 
      };
    }
    
  } catch (error) {
    console.error('Erro ao buscar configuração BD, usando fallback JSON:', error.response?.data || error.message);
    
    return {
      existeNoticiasProprias: false,
      existeNoticiasCarmine: false,
      topNoticias: infoJson.Layout?.Noticias?.top ?? 0,
      tipoDestaque: infoJson.Layout?.Noticias?.destaque ?? 0,
      origemBD: false,
      externas: infoJson.Noticias?.externas ?? false,
      erro: true
    };
  }
}
async function getAlbumClientesConfig(infoJson) {
  try {
    const API_URL = {
      method: 'GET',
      url: `${global.ApiLink}/v1/${
        infoJson.Stand.Easymanager ? 'easymanager' : 'easydata'
      }/easysite/GetAlbumClientesConfig/`,
      params: { dealer_id: infoJson.Stand.Anunciante },
      headers: { token: process.envx.REACT_APP_TOKEN_API },
    };

    const res = await axios.request(API_URL);
    const config = res.data?.config;

    if (config && typeof config === 'object') {
      return {
        topAlbum: config.top_noticias ?? 0,
        tipoDestaque: config.tipo_destaque === 'destaques' ? 1 : 0, // 1 = destaques, 0 = recentes (exemplo)
      };
    } else {
      return {
        topAlbum: 0,
        tipoDestaque: 0,
      };
    }
  } catch (error) {
    console.error(
      'Erro ao buscar configuração do álbum de clientes:',
      error.response?.data || error.message,
    );
    return {
      topNoticias: 0,
      tipoDestaque: 0,
    };
  }
}

export {
  getInfoEmpresa,
  getPlugins,
  getPesquisa,
  getDestaque,
  getInfoAtivarSite,
  getBanner,
  getServicoOficina,
  getHorarios,
  getIntervaloPreco,
  getIntervaloMensalidade,
  getInfoTextos,
  getPrivacidade,
  getInfoPopUp,
  getCookies,
  getUltimasEntradas,
  getOrdenacaoSeccoes,
  getZonas,
  getNoticiasConfig,
  getVendidos,
  getIntervaloPrecoTipo,
  getIntervaloMensalidadeTipo,
  getAlbumClientesConfig,
  getEditarServicos,
  getTipoListagem,
};
